/*@ngInject*/
const AdvancedFilterListController = function ($scope, advancedFilterModel, advancedFilterMediator,
                                               coreConstant, currentUserModel, filterCriterionUiType,
                                               localization) {

    this.$onInit = function () {
        localization.getTranslationsByKeys([this.translationsKey, 'advancedFilter']).then((translations) => {
            this.clearFilterLabel = translations.clearButton;
        });
    }

    $scope.$on(coreConstant.event.FILTER_UPDATED, function (event, advancedFilterType, isProgramatic) {
        if (isProgramatic) {
            this.programaticUpdateFilter();
        } else {
            this.userUpdateFilter();
        }
    }.bind(this));

    this.clearFilter = function (isAfterSplitter) {
        let items = this.filterModel.selectedFilterCriterionTemplates,
            splitterIndex;

        if (!this.oneClearFilter) {
            splitterIndex = _.findIndex(items, function (item) {
                return item.uiType === filterCriterionUiType.UI_BREAKER;
            });

            if (isAfterSplitter) {
                items = items.slice(splitterIndex, items.length);
            } else {
                items = items.slice(0, splitterIndex);
            }
        }

        _.each(items, function (item) {
            $scope.$broadcast(coreConstant.event.FILTER_CLEARED, item.id);
        });

        this.updateFilter();
    };

    this.userUpdateFilter = _.debounce(function () {
        this.updateFilter();
    }.bind(this), 500);

    this.programaticUpdateFilter = _.debounce(function () {
        this.updateFilter();
    }.bind(this), 200);

    this.updateFilter = function () {
        let filter = advancedFilterModel.buildCurrentFilter(this.advancedFilterType);
        if (!advancedFilterModel.getAdvancedFilterModel(this.advancedFilterType).temporary) {
            filter.temporary = true;
            filter.uri = null;
            filter.id = null;
        }
        filter.userId = currentUserModel.getCurrentUser().userId;
        advancedFilterMediator.saveFilter(filter).then(function (filter) {
            $scope.$emit(coreConstant.event.FILTER_SAVED, filter);
        });
    }
};

angular.module('umCore')
    .controller('advancedFilterListController', AdvancedFilterListController);
